import { render } from "./StoreConfigurationAfterSalesService.vue?vue&type=template&id=7ac66ac6"
import script from "./StoreConfigurationAfterSalesService.vue?vue&type=script&lang=js"
export * from "./StoreConfigurationAfterSalesService.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__